module.exports = __webpack_public_path__ + "img/form-sign.93cc7e4a.svg";